export default class Constants {
  public static Pages = class {
    static home = '/';
    static changePassword = '/change-password';
    static changePasswordConfirm = '/change-password-confirm';
    static loggingTest = '/logging-test';
    static accessError = '/access-error';
    static technicalError = '/technical-error';
    static notFound = '/not-found';
    static catchAll = '*';
  };

  public static DealersExperience = class {
    static unifi = 'unifi';
    static acura = 'acura';
    static honda = 'honda';
    static hyundai = 'hyundai';
    static genesis = 'genesis';
  };
}
